export default "__VITE_ASSET__DVy8UHYo__"